import srOnly from '@fukku/styles/src/srOnly.module.css'
import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import textHeadingL from '@fukku/styles/texts/textHeadingL.module.css'
import textHeadingM from '@fukku/styles/texts/textHeadingM.module.css'
import cx from 'classix'
import type { ReactNode } from 'react'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import styles from '../../ModalHeader.module.css'

export function HeadersTitles({
	title,
	subtitle,
	showTitle,
	hasSheetTitle,
	hasCenteredTitle,
	className,
}: {
	readonly title: string
	readonly showTitle: boolean
	readonly hasSheetTitle: boolean
	readonly hasCenteredTitle: boolean
	readonly subtitle?: string | ReactNode
	readonly className?: string
}) {
	if (!showTitle) {
		return (
			<div
				className={cx(srOnly.className, styles.title, textHeadingL.className)}
			>
				{title}
			</div>
		)
	}

	return (
		<div
			className={cx(
				className,
				styles.titles,
				hasCenteredTitle && styles.centered
			)}
		>
			<h1
				className={cx(
					styles.title,
					hasSheetTitle ? textHeadingM.className : textHeadingL.className,
					applyStylesIf(hasSheetTitle, styles.sheetTitle)
				)}
				data-testid='modal.title'
			>
				{title}
			</h1>
			{!!subtitle && (
				<h2
					className={cx(styles.subtitle, textBodyS.className)}
					data-testid='modal.subtitle'
				>
					{subtitle}
				</h2>
			)}
		</div>
	)
}
